import { get } from 'lodash';
import dateTimeMixin from '@/mixins/date-time';
import vuetifyColors from 'vuetify/lib/util/colors';

export default {
  name: 'ChartHeatmapMixin',
  mixins: [dateTimeMixin],
  methods: {
    getHeatmapChartOptions() {
      const lowestHeatValue = get(this.widget, 'chartOptions.heatmap.lowestHeatValue', 0);
      const highestHeatValue = get(this.widget, 'chartOptions.heatmap.highestHeatValue', 100);

      const dateRangeStart = new Date(this.dateRange.start);
      const dateRangeEnd = new Date(this.dateRange.end);

      const amountOfSections = 24;
      const sections = [];
      // split the range into 12 sections of equal length (time intervals) and add an entry for each section to the sections array, the item should be `STARTISO_>_ENDISO`
      const sectionLength = (dateRangeEnd - dateRangeStart) / amountOfSections;
      for (let i = 0; i < amountOfSections; i++) {
        const sectionStartDate = new Date(dateRangeStart);
        sectionStartDate.setMilliseconds(sectionStartDate.getMilliseconds() + i * sectionLength);

        const sectionEndDate = new Date(sectionStartDate);
        sectionEndDate.setMilliseconds(sectionEndDate.getMilliseconds() + sectionLength);

        const formattedSectionStartDate = this.formatDateTime(
          sectionStartDate,
          get(this.widget, 'chartOptions.dateTimeFormat')
        );
        const formattedSectionEndDate = this.formatDateTime(
          sectionEndDate,
          get(this.widget, 'chartOptions.dateTimeFormat')
        );
        sections.push({
          label: `${formattedSectionStartDate} - ${formattedSectionEndDate}`,
          start: sectionStartDate,
          end: sectionEndDate,
        });
      }

      const stateNames = [];
      const data = [];

      const valueDetermination = get(this.widget, 'chartOptions.heatmap.valueDetermination', 'max');

      this.chartData.forEach((twin) => {
        twin.states.forEach((state) => {
          const stateName = this.getStateLabel(twin, state.state);
          stateNames.push(stateName);

          const nonNullHistoryItems = state.history.filter((item) => item.value !== null);

          sections.forEach((section) => {
            // TODO: get the value from the chart data
            const historyItemsOfSection = nonNullHistoryItems
              .filter((item) => {
                const timestamp = new Date(item.timestamp);
                return timestamp >= section.start && timestamp <= section.end;
              })
              .map((item) => ({
                ...item,
                value: Number(item.value),
              }))
              .filter((item) => !isNaN(item.value));

            let stateSectionValue = 0;
            if (historyItemsOfSection.length > 0) {
              switch (valueDetermination) {
                case 'min':
                  stateSectionValue = Math.min(...historyItemsOfSection.map((item) => item.value));
                  break;
                case 'average':
                  stateSectionValue =
                    historyItemsOfSection.reduce((sum, item) => sum + item.value, 0) / historyItemsOfSection.length;
                  break;
                case 'sum':
                  stateSectionValue = historyItemsOfSection.reduce((sum, item) => sum + item.value, 0);
                  break;
                case 'earliest':
                  stateSectionValue = historyItemsOfSection[0].value;
                  break;
                case 'latest':
                  stateSectionValue = historyItemsOfSection[historyItemsOfSection.length - 1].value;
                  break;
                case 'max':
                default:
                  stateSectionValue = Math.max(...historyItemsOfSection.map((item) => item.value));
                  break;
              }
            }

            data.push([section.label, stateName, stateSectionValue]);
          });
        });
      });

      return {
        tooltip: {
          trigger: 'item',
        },
        xAxis: {
          type: 'category',
          data: sections.map((section) => section.label),
          splitArea: {
            show: true,
          },
        },
        yAxis: {
          type: 'category',
          data: stateNames,
          splitArea: {
            show: true,
          },
        },
        visualMap: {
          min: lowestHeatValue,
          max: highestHeatValue,
          orient: 'vertical',
          right: 0,
          top: 'center',
          inRange: {
            color: [
              vuetifyColors.green.darken2,
              vuetifyColors.green.base,
              vuetifyColors.orange.base,
              vuetifyColors.red.base,
            ],
          },
        },
        grid: {
          right: 50,
          left: 150,
        },
        series: [
          {
            type: 'heatmap',
            data,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
          },
        ],
      };
    },
  },
};
